import React, { useEffect } from "react";
import Ellipsis from "./Ellipsis";
import { useParams, useNavigate } from "react-router-dom";
import { SourceBaseViewType, useCreateOpenAiChat } from "../api-generated";

type NewChatParams = {
  query?: string;
};

const NewChat: React.FC = () => {
  const navigate = useNavigate();

  const createOpenAiChatMutation = useCreateOpenAiChat();
  const { query } = useParams<NewChatParams>();

  useEffect(() => {
    createOpenAiChatMutation.mutate(
      { data: { startingQuery: query } },
      {
        onSuccess: (source) => {
          navigate(`/sources/${SourceBaseViewType.openai_chat}/${source.id}`);
        },
      }
    );
  }, [query]);

  return (
    <div className="flex flex-col">
      <div>
        {query ? (
          <>
            Creating chat with query: <b>"{query}"</b>
          </>
        ) : (
          <>Creating new chat</>
        )}

        <Ellipsis />
      </div>
    </div>
  );
};

export default NewChat;
